export default "__VITE_ASSET__Bw7beO6F__"